import React, { useState } from 'react';

const RenderCellSplit = ({ value, maxLength = 50 }) => {
    const [isTruncated, setIsTruncated] = useState(true);

    const toggleTruncate = () => {
        setIsTruncated(!isTruncated);
    };

    const displayText = isTruncated ? (value.length > maxLength ? `${value.substring(0, maxLength)}...` : value) : value;

    const textStyle = {
        cursor: 'pointer',
        wordWrap: 'break-word',
        wordBreak: 'break-all',
        maxWidth: '100%',
        overflowWrap: 'break-word',
        hyphens: 'auto'
    };

    return (
        <div onClick={toggleTruncate} style={textStyle} title={"Déplier le texte"}>
            {displayText}
        </div>
    );
};

export default RenderCellSplit;
